export default {
  disabled: {
    title: 'Fakturering administreres ikke på platformen',
    description:
      'Abonnementer og fakturaer er ikke tilgængelige, fordi faktureringen mellem dig og dine restauranter afregnes uden for platformen. Udbetalinger, kontoudtog og rapporter er fortsat tilgængelige.',
  },
};
